import { useLanguage } from './i18n';

export const sellerPhone = '+7 901 349-10-47';
export const sellerPhoneHref = 'tel:+79013491047';
export const sellerEmail = 'fizuli_zamanov@mail.ru';

export const dagestanPhone = '+7 929 880-10-93';
export const dagestanPhoneHref = 'tel:+79298801093';

export const cisDistributorPhone = '+996 700 773-737';
export const cisDistributorPhoneHref = 'tel:+996700773737';

export function ContactsCard() {
  const { messages } = useLanguage();
  const copy = messages.contacts;

  return (
    <div className="contacts-card">
      <a href={sellerPhoneHref}>
        <span>{copy.phone}</span>
        {sellerPhone}
      </a>
      <a href={`mailto:${sellerEmail}`}>
        <span>Email</span>
        {sellerEmail}
      </a>
      <p>
        <span>{copy.responseTime}</span>
        {copy.responseValue}
      </p>
    </div>
  );
}

export function DagestanContactsCard() {
  const { messages } = useLanguage();
  const copy = messages.contacts;

  return (
    <div className="contacts-card">
      <p>
        <span>{copy.pharmacy}</span>
        {copy.pharmacyName}
      </p>
      <a href={dagestanPhoneHref}>
        <span>{copy.phone}</span>
        {dagestanPhone}
      </a>
      <p>
        <span>{copy.address}</span>
        {copy.dagestanAddress}
      </p>
    </div>
  );
}

export function CisDistributorContactsCard() {
  const { messages } = useLanguage();
  const copy = messages.contacts;

  return (
    <div className="contacts-card">
      <p>
        <span>{copy.company}</span>
        {copy.cisCompany}
      </p>
      <a href={cisDistributorPhoneHref}>
        <span>{copy.phone}</span>
        {cisDistributorPhone}
      </a>
      <p>
        <span>{copy.address}</span>
        {copy.cisAddress}
      </p>
    </div>
  );
}
